module.exports = __webpack_public_path__ + "static/media/automa-logo-white.1f4b68f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/automa-logo-white.png
// module id = 484
// module chunks = 1